export default __webpack_public_path__ + "static/media/diagnosis-selected.633f0552.svg";